"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withErrorBoundary = exports.ErrorBoundary = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: props.error || null };
        return _this;
    }
    ErrorBoundary.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props === prevProps || this.state !== prevState) {
            return;
        }
        if (!this.state.error && this.props.error !== prevProps.error) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ error: this.props.error });
        }
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error });
        console.error(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _this = this;
        if (this.state.error) {
            var Fallback = this.props.fallback;
            return Fallback
                ? (0, jsx_runtime_1.jsx)(Fallback, { error: this.state.error, dismissError: function () { return _this.setState({ error: null }); } })
                : ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ borderRadius: "4px", mt: 1 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Alert, __assign({ color: "error" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mb: 2 }, { children: [this.state.error.name || 'Error', " ", this.state.error.message] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return _this.setState({ error: null }); } }, { children: "Retry" }))] })) })));
        }
        // when there's no error, render children untouched
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.default.PureComponent));
exports.ErrorBoundary = ErrorBoundary;
var withErrorBoundary = function (ComponentThatMightFail) { return function (props) { return ((0, jsx_runtime_1.jsx)(ErrorBoundary, { children: (0, jsx_runtime_1.jsx)(ComponentThatMightFail, __assign({}, props)) })); }; };
exports.withErrorBoundary = withErrorBoundary;
